/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Document_Uploaded_BodyInputs */

const en_notifications_document_uploaded_body = /** @type {(inputs: Notifications_Document_Uploaded_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new document was uploaded on a case where you have an open task.`)
};

const pt_br2_notifications_document_uploaded_body = /** @type {(inputs: Notifications_Document_Uploaded_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um novo documento foi enviado em um caso onde você tem uma tarefa em aberto.`)
};

/**
* | output |
* | --- |
* | "A new document was uploaded on a case where you have an open task." |
*
* @param {Notifications_Document_Uploaded_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_document_uploaded_body = /** @type {((inputs?: Notifications_Document_Uploaded_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Document_Uploaded_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_document_uploaded_body(inputs)
	return pt_br2_notifications_document_uploaded_body(inputs)
});